module.exports = __webpack_public_path__ + "static/media/design-spark-tablet.412eb03a.jpeg";